module.exports = __webpack_public_path__ + "static/img/seo.79bab8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/services/seo.jpg
// module id = biul
// module chunks = 0